import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { SaveMessageComponent } from '../../directive/save-message/save-message.component';
import { ActivatedRoute } from '@angular/router';
import { UserService } from '../../_services/user.service';
import { Subscription } from 'rxjs';
import { PhoneAuthenticationService } from '../../_services/phone-authentication.service';
import { ApiService } from '../../_services/api.service';
import { AngularFirestore } from 'angularfire2/firestore';

@Component({
  selector: 'app-phone-update',
  templateUrl: './phone-update.component.html',
  styleUrls: ['./phone-update.component.css']
})
export class PhoneUpdateComponent implements OnInit {
  updateModel: any = {};
  confirmation: any;
  userId = localStorage.getItem('currentUserId');
  isSubmit = true;
  lastUser;
  user: any;
  private subscription: Subscription = new Subscription();
  constructor(
    private afs: AngularFirestore,
    private route: ActivatedRoute,
    private userService: UserService,
    private apiService: ApiService,
    private phoneAuthService: PhoneAuthenticationService,
    private dialog: MatDialog) {

    this.subscription.add(this.userService.getUser().subscribe(user => {
      this.user = user;
    }));
  }

  ngOnInit() {
    this.updateModel.phoneNumber = this.route.snapshot.queryParams['phone'];
    if (this.updateModel.phoneNumber) {
      this.signinphone(this.updateModel.phoneNumber);
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  onSubmit() {
    this.isSubmit = false;
  }

  onlyNumberKey(event) {

    return event.charCode >= 48 && event.charCode <= 57;
  }

  signinphone(phoneNumber) {
    this.phoneAuthService.sendOtp(this.updateModel.phoneNumber)
      .then(result => { this.confirmation = result; }).catch((error) => {
      })
  }

  confirmationResult() {
    var isValid = this.phoneAuthService.confirm(this.updateModel.code);
    if (isValid) {
      if (!this.user.phoneNumber) {
        this.getPoint();
      }
      else {
        this.subscription = this.userService.getUser().subscribe(elem => {
          this.lastUser = elem;
        })
        var users = {
          userKey: this.userId,
          agreement: this.lastUser.agreement || null,
          birthday: this.dateFormat(new Date(this.lastUser.birthday.year
            + "/" + this.lastUser.birthday.month + "/" + this.lastUser.birthday.day)),
          totalPoint: this.lastUser.totalPoint || null,
          username: this.lastUser.username,
          email: this.lastUser.email,
          firstname: this.lastUser.firstname,
          isEmailVerified: this.lastUser.isEmailVerified || null,
          isSecret: this.lastUser.isSecret || null,
          joinDate: this.dateFormat(new Date(this.lastUser.joinDate)),
          lastname: this.lastUser.lastname,
          level: this.lastUser.level,
          city: this.lastUser.city || null,
          phoneNumber: this.updateModel.phoneNumber,
          education: this.lastUser.education || null,
          gender: this.lastUser.gender || null,
          job: this.lastUser.job || null,
          profileImage: this.lastUser.profileImage || null,
          following: this.lastUser.following ? this.lastUser.following.length : 0,
          followers: this.lastUser.followers ? this.lastUser.followers.length : 0
        }
        this.afs.collection('users').doc(this.userId).update({ phoneNumber: this.updateModel.phoneNumber }).then(() => {
          this.apiService.sqlPost('users/insertUpdateUser', users).map(res => res.json()).toPromise().then(a => a);
        })

        this.dialog.open(SaveMessageComponent, {
          width: '400px',
          data: {
            message: "Değişiklikler kaydedildi.",
            type: "route",
            goTo: "/profile-update"
          }
        });
      }
    } else {
      this.dialog.open(SaveMessageComponent, {
        width: '400px',
        data: {
          message: "Kodu doğru girmelisin.",
          type: "update"
        }
      });
    }
   

  }

  dateFormat(data) {
    if (data.length == 10) {
      return data;
    }
    var dd = data.getDate();
    var mm = data.getMonth() + 1; //January is 0!
    var yyyy = data.getFullYear();

    if (dd < 10) {
      dd = '0' + dd;
    }
    if (mm < 10) {
      mm = '0' + mm;
    }

    data = yyyy + '-' + mm + '-' + dd;
    return data;
  }
  async getPoint() {
    const point = 20;
    if (!this.user.phoneNumber) {
      this.afs.collection('users').doc(this.userId).ref.get().then((data => {
        this.afs.collection('users').doc(this.userId).update({
          point: {
            totalPoint: data.data().point.totalPoint ? data.data().point.totalPoint + point : point
          }
        });

      }))
      await this.afs.collection('users').doc(this.userId).update({ phoneNumber: this.updateModel.phoneNumber });
    }

    await this.dialog.open(SaveMessageComponent, {
      width: '400px',
      data: {
        message: point + " puan kazanarak " + this.user.point.totalPoint + " puana yükseldin.",
        type: "route",
        goTo: "/profile-update"
      }
    });

  }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/profile-update/phone-update/phone-update.component.ts